import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import { Button, Card, Form, Row, Col, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import { nanoid } from "nanoid";
import { AddForm } from "./components/AddForm";
import { useSelector } from "react-redux";
import { IAllStates } from "../../store/rootReducer";
import { IExport } from "../exports/dto/IExports";
import { ErrorToast } from "../../shared/toasters/toasters";
import { ClientService } from "../clients/service";
import { SingleValue } from "react-select";
import { ContentService } from "../content/service";
import { DataHistoryList } from "./components/DataHistoryList";
import _debounce from "lodash/debounce";
import { Link } from "react-router-dom";
import { Stepper } from "./components/Stepper";
import { WorkflowStep } from "./components/WorkflowStep";

const defaultContentTitle = {
  title: "",
  location: "",
  files: [
    {
      id: null,
      name: "",
      path: "",
      index: null,
    },
  ],
};
export const ClientDashboard = () => {
  const { search } = useLocation();
  const navigate = useNavigate();
  const [files, setFiles] = useState<any[]>([]);
  const [clientFilterId, setClientFilterId] = useState(null);
  const [termFilter, setTermFilter] = useState("");
  const [dataHistoryList, setDataHistoryList] = useState(undefined);
  const [triggerUpdate, setTriggerUpdate] = useState(false);
  const [documentFile, setDocumentFile] = useState<any>();
  const [clientList, setClientList] = useState<IExport[]>([]);
  const { accessRights } = useSelector((state: IAllStates) => state.auth);
  const [createField, setCreateField] = useState(true);
  const [selectedContent, setSelectedContent] = useState({});
  const [show, setShow] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);
  const [pagination, setPagination] = useState({
    page: 1,
    perPage: 10,
    title: "",
    client: null,
  });
  const [contentTitle, setContentTitle] = useState(defaultContentTitle);
  const currentUser = JSON.parse(localStorage.getItem("currentUser") as string);
  const isManager = currentUser?.roles.includes("ROLE_MANAGER");
  const isAdmin = currentUser?.roles.includes("ROLE_ADMIN");
  const isCompanyAdmin = currentUser?.roles.includes("ROLE_COMPANY_ADMIN");
  const handleShow = () => setShow(true);
  const [clientParams, setClientParams] = useState({
    page: 1,
    perPage: 10,
  });
  const [translatorData, setTranslatorData] = useState<any>({ contents: [] });
  const [checkedValues, setCheckedValues] = useState<number[]>([]);
  const { id } = useParams();
  const { t } = useTranslation();
  const changeClientHandler = _debounce((targetValue: any) => {
    setClientParams((prev) => ({ ...prev, name: targetValue }));
  }, 200);
  const changeFilterHandler = _debounce(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const { value, name } = event.target;
      setTermFilter(value);
      setPagination({
        page: 1,
        perPage: 12,
        [name]: value,
        client: clientFilterId,
      } as any);
    },
    200
  );
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const handlePages = (updatePage: number) => {
    setPagination({ ...pagination, page: updatePage });
    setPage(updatePage);
  };
  const checkAccess = () => {
    if (isManager || isAdmin || isCompanyAdmin) {
      return false;
    } else {
      return true;
    }
  };
  const changeFilterClientHandler = (
    selectedSingle: SingleValue<IExport | null>,
    inputKey: string
  ) => {
    if (Number(selectedSingle?.value)) {
      setClientFilterId(selectedSingle?.value as any);
      setPagination({
        page: 1,
        perPage: 12,
        title: termFilter,
        client: clientFilterId,
      } as any);
    } else {
      setClientFilterId(null);
      setPagination({
        page: 1,
        perPage: 12,
        title: termFilter,
        client: null,
      } as any);
    }
    setClientFilterId(selectedSingle?.value as any);
    setPagination((prev) => ({ ...prev, [inputKey]: selectedSingle?.value }));
  };
  const changeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    // @ts-ignore
    const { name, value } = event.target;
    setContentTitle((prev: any) => ({ ...prev, [name]: value }));
  };
  //   const lightOrDarkMode = useSelector(
  //     (state: IAllStates) => state.lightOrDarkMode
  //   );
  const submitHandler = (event: React.FormEvent) => {
    event.preventDefault();
    // if (contentId && contentId !== 0) {
    //   const formData = new FormData();
    //   if (contentTitle?.files?.length > 0) {
    //     for (let i = 0; i < contentTitle?.files?.length; i++) {
    //       if (files[i]?.size) {
    //         formData.append("files", files[i]);
    //       }
    //     }
    //   }
    //   formData.append(
    //     "body",
    //     JSON.stringify({
    //       title: (contentTitle as any)?.title,
    //       source: (contentTitle as any)?.location,
    //     })
    //   );

    //   ContentWorkflowService.updateContentBaseById(
    //     id as any,
    //     contentId,
    //     formData
    //   )
    //     .then((response) => {
    //       if (response?.id) {
    //         SuccessToast("Success added content");
    //         setCreateField(false);
    //         setContentTitle(defaultContentTitle);
    //         setDocumentFile(undefined);
    //         setFiles([]);
    //         setTriggerUpdate((prev) => !prev);
    //       }
    //     })
    //     .catch((error) => ErrorToast(error));
    // } else {
    //   const formData = new FormData();
    //   if (contentTitle?.files?.length) {
    //     for (let i = 0; i < contentTitle?.files?.length; i++) {
    //       formData.append("files", files[i]);
    //     }
    //   }
    //   formData.append(
    //     "body",
    //     JSON.stringify({
    //       title: (contentTitle as any)?.title,
    //       source: (contentTitle as any)?.location,
    //     })
    //   );

    //   ContentWorkflowService.createBase(formData, id as any)
    //     .then((response) => {
    //       if (response?.id) {
    //         SuccessToast("Success added content");
    //         setCreateField(false);
    //         setContentTitle(defaultContentTitle);
    //         setDocumentFile(undefined);
    //         setFiles([]);
    //         setTriggerUpdate((prev) => !prev);
    //       }
    //     })
    //     .catch((error) => ErrorToast(error));
    // }
  };
  const handleKeyDown = (e: any) => {
    if (e.key === "Enter") {
      submitHandler(e);
    }
  };
  const handleFilesInput = (i: number, e: any, element: any) => {
    if (e.target.files.length) {
      let newFormValuesImg = [
        ...contentTitle.files.map((file: any, index: any) =>
          index === i
            ? { ...file, index: files.length, name: e.target.files[0]?.name }
            : file
        ),
      ];
      (newFormValuesImg as any)[i][e.target.name] = URL.createObjectURL(
        e.target.files[0]
      );

      setFiles((prev: any) => [...prev, e.target.files[0]]);
      setContentTitle((prev: any) => ({ ...prev, files: newFormValuesImg }));
    }
  };
  const addFormFields = () => {
    setContentTitle((prev: any) => ({
      ...prev,
      files: [
        ...prev.files,
        {
          id: null,
          path: "",
          name: "",
          index: null,
        },
      ],
    }));
    const newFormData = [...contentTitle.files];
    const id = nanoid();
    newFormData.push({
      id: null,
      path: "",
      name: "",
      index: null,
    });
    setContentTitle((prev: any) => ({ ...prev, files: newFormData }));
  };

  const removeFormFields = (index: any, id: any, item: any) => {
    if (contentTitle?.files.length === 1) {
      setContentTitle((prev: any) => ({
        ...prev,
        files: [
          ...prev.files,
          {
            id: null,
            path: "",
            name: "",
            index: null,
          },
        ],
      }));
    }
    if (id === null) {
      setContentTitle((prev: any) => ({
        ...prev,
        files: prev.files.filter((input: any, idx: any) => idx !== index),
      }));
      setFiles((prev: any) =>
        prev.filter((input: any) => input?.path != item?.path)
      );
    } else {
      // ContentWorkflowService.deleteFile(id)
      //   .then((response) => {
      //     setContentTitle((prev: any) => ({
      //       ...prev,
      //       files: prev.files.filter((input: any, idx: any) => idx !== index),
      //     }));
      //     SuccessToast(t(`toasts.successfully_deleted`));
      //   })
      //   .catch((error) => ErrorToast(error));
    }
  };
  useEffect(() => {
    ClientService.getAllClients({
      page: 1,
      perPage: 0,
    })
      .then((response) => {
        const { data } = response;
        setClientList(
          data?.map((client) => ({
            ...client,
            label: client.name,
            value: client.id,
          }))
        );
      })
      .catch((error) => ErrorToast(error));
  }, [clientParams]);
  useEffect(() => {
    ContentService.getAllContents(pagination)
      .then((data) => {
        if (pagination?.page > 1 && pagination?.page > data?.totalPages) {
          setPage(data?.totalPages);
          setPagination({ ...pagination, page: data?.totalPages });
          setTotalPages(data?.totalPages);
          setDataHistoryList(data?.data);
        } else {
          setDataHistoryList(data?.data);
          setTotalPages(data?.totalPages);
        }
      })
      .catch((error) => ErrorToast(error));
  }, [triggerUpdate, pagination]);
  return (
    <>
      <Helmet>
        <title>{t("side_bar.client_dashboard")}</title>
      </Helmet>
      {checkAccess() && (
        <div className="card">
          <div className="card-body">
            <Stepper step={"workflows"} />
          </div>
          <WorkflowStep />
        </div>
      )}
    </>
  );
};
